/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { useEffect, useState } from 'react';

/* Import libraries */
import {
    APPLICATION_ERROR_LOG_CHANGE_EVENT,
    APPLICATION_ERROR_LOG_STORAGE_KEY,
    getApplicationErrorLog,
} from '@/lib/app/errorLog';

function getErrorLogCount(): number {
    return getApplicationErrorLog().length;
}

/** Keeps the navigation badge synchronized with local and cross-tab log changes. */
export function useApplicationErrorLogCount(): number {
    const [errorLogCount, setErrorLogCount] = useState(getErrorLogCount);

    useEffect(() => {
        const updateErrorLogCount = () => {
            setErrorLogCount(getErrorLogCount());
        };
        const handleStorageChange = (event: StorageEvent) => {
            if (event.key === APPLICATION_ERROR_LOG_STORAGE_KEY) {
                updateErrorLogCount();
            }
        };

        window.addEventListener(APPLICATION_ERROR_LOG_CHANGE_EVENT, updateErrorLogCount);
        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener(APPLICATION_ERROR_LOG_CHANGE_EVENT, updateErrorLogCount);
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    return errorLogCount;
}
